import React, { useCallback, useEffect, useState } from "react"

import { StudioPermissions } from "@shared/apis/studioPermissions"
import { StockCounselList } from "@shared/components"
import { useViewers } from "@shared/hooks"

import { useSchedule } from "../../@shared/contexts"
import { useUserActionStore } from "../../@shared/stores/streamerStore"
import ShortForm from "../../live/components/sidebar/contents/ShortForm"
import Tabs from "./Tabs"
import UtilBox from "./UtilBox"
import { Viewers, VIEWERS_HEIGHT } from "./Viewers"
import UserAction from "./Viewers/UserAction"

interface Props {
  studioPermissions?: StudioPermissions
}

function Contents({ studioPermissions }: Props) {
  const {
    userAction: action,
    setUserAction: setAction,
    closeUserAction: closeAction,
    handleUserAction: handleAction,
  } = useUserActionStore()
  const { managers, viewers } = useViewers()
  const { schedule } = useSchedule()
  const [tab, setTab] = useState<Tab>("시청자")
  // 숏폼 탭 클릭할 때마다 값을 바꿔 ShortForm의 refreshTrigger로 넘겨 API를 다시 호출한다.
  const [shortFormRefreshKey, setShortFormRefreshKey] = useState(0)

  const [isSearch, setIsSearch] = useState<boolean>(false)
  const [searchKeyword, setSearchKeyword] = useState<string>("")

  const paymentInformation = schedule?.paymentInformation
  // 스케줄 로드 전(undefined)에는 유료 여부를 알 수 없으므로 구분해서 다룬다
  const isScheduleLoaded = paymentInformation !== undefined
  const showViewerTab = paymentInformation === "PAID"
  const showViewers = paymentInformation === "PAID"

  const handleIsSearchChange = useCallback(
    (active: boolean) => setIsSearch(active),
    [],
  )

  const handleKeywordChange = useCallback(
    (keyword: string) => setSearchKeyword(keyword),
    [],
  )

  useEffect(() => {
    if (!isSearch) return

    setTab("시청자")
  }, [isSearch, setTab])

  // 스케줄 로드 결과 시청자 탭이 없는 방송(유료 아님)이면 숏폼 탭을 기본으로 보여준다
  // (로드 전에 전환해버리면 유료 방송에서도 기본 탭이 숏폼이 되어버림)
  useEffect(() => {
    if (isScheduleLoaded && !showViewerTab) {
      setTab("숏폼 / AI 요약")
    }
  }, [isScheduleLoaded, showViewerTab])

  return (
    <>
      <UtilBox
        users={managers.concat(viewers)}
        searchKeyword={searchKeyword}
        onSearchKeywordChange={handleKeywordChange}
        isSearch={isSearch}
        onIsSearchChange={handleIsSearchChange}
        showUserSearchButton={false}
      />
      <Tabs
        tab={tab}
        setTab={setTab}
        showViewerTab={showViewerTab}
        onShortFormClick={() => setShortFormRefreshKey((key) => key + 1)}
      />
      <Viewers
        isActive={showViewers && tab === "시청자"}
        managers={managers}
        viewers={viewers}
        searchKeyword={searchKeyword}
        studioPermissions={studioPermissions}
      />
      {tab === "숏폼 / AI 요약" && (
        <ShortForm
          refreshTrigger={shortFormRefreshKey}
          streamerId={schedule?.user.id}
          height={VIEWERS_HEIGHT}
          isStreamerView
        />
      )}
      {action?.isActive ? (
        <UserAction
          {...action!.props}
          closeAction={closeAction}
          studioPermissions={studioPermissions}
        />
      ) : null}
    </>
  )
}

export default Contents

export type Tab = "종목분석" | "시청자" | "숏폼 / AI 요약"
